import React from 'react';

const IconArrowRightLong: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    stroke='currentColor'
    fill='currentColor'
    strokeWidth='0'
    viewBox='0 0 448 512'
    height='16'
    width='16'
    xmlns='http://www.w3.org/2000/svg'
    aria-hidden='true'
    focusable='false'
    {...props}
    className={`icon icon-arrow-right-long${props.className ? props.className : ''}`}
  >
    <path d='M502.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l370.7 0-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128z'></path>
  </svg>
);

export default IconArrowRightLong;
